export default __webpack_public_path__ + "static/bbq-3-c-29ca0b7edca5d2f4ec8312c5efa130c6.webp";